import { ajax } from "../settings/settings";

export const getPublicConfigs = callback => {
  ajax
    .get("/web/rest/publicConfigs")
    .then(function(response) {
      if (response) {
        if (callback) {
          callback(response);
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const getMbConfigs = callback => {
  ajax
    .get("/web/rest/mbconfig")
    .then(function(response) {
      if (response) {
        if (callback) {
          callback(response);
        }
      }
    })
    .catch(function(error) {
      $("body").addClass("ready");
      alertBox({
        message: "暂时无法连接服务器，请稍后再试！",
        type: "info",
        confirmFunc: function() {
          location.reload();
        }
      });
      return Promise.reject(error);
    });
};

export const generateVCode = callback => {
  ajax
    .request({
      url: "/web/rest/code",
      method: "get",
      responseType: "arraybuffer",
      params: { _: Date.now() }
    })
    .then(function(response) {
      if (response) {
        const imgString = "data:image/png;base64," + new Buffer(response.data, "binary").toString("base64");

        if (callback) {
          callback(imgString);
        } else {
          return imgString;
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};
